import {Component, OnDestroy, OnInit} from '@angular/core';

import {RegistryService} from "../../../../../services/registry.service";
import {AuthService} from "../../../../../../../services/auth.service";
import {PaymentService} from "../../../../../services/payment.service";
import {ActivatedRoute} from "@angular/router";
import {GoogleAnalyticsService} from "../../../../../services/google-analytics.service";
import {OrderService} from "../../../../../services/order.service";

@Component({
    selector: 'app-knet-order-success',
    templateUrl: './knet-order-success.component.html',
    styleUrls: ['./knet-order-success.component.css']
})
export class KnetOrderSuccessComponent implements OnInit, OnDestroy {

    userLoggedOutEvent;
    orderId = null;

    payment_button_visibility = false;

    order_id = "";
    transaction_id = "";
    txn_type = "";
    method = "";
    txn_id = "";
    created_at = "";

    constructor(public registry: RegistryService,
                private authService: AuthService,
                private googleService: GoogleAnalyticsService,
                private orderService: OrderService,
                private paymentService: PaymentService,
                private route: ActivatedRoute
    ) {

    }

    ngOnInit(): void {


        this.route.queryParams.subscribe(paramMap => {

            this.order_id = paramMap.orderid;
            this.transaction_id = paramMap.transaction_id;
            this.txn_type = paramMap.txn_type;
            this.method = paramMap.method;
            this.txn_id = paramMap.txn_id;
            this.created_at = paramMap.created_at;

            //register purchase
            //load the order
            this.orderService.getOrderDetails(this.order_id).subscribe(result => {

                //register.

                let order = result[0];
                console.log(order);
                let products = [];

                for (let i = 0; i < order.items.length; i++) {
                    products.push({
                        'name': order.items[i].name,
                        'sku': order.items[i].sku,
                        'price': order.items[i].base_price,
                        'category': '',
                        'quantity': 1
                    });
                }

               // console.log(products)
                let reg_tag = localStorage.getItem("pur_reg_" + this.order_id);

                if (!reg_tag) {
                  //  console.log("Registering with google.")
                    this.googleService.purchase(this.transaction_id, order.base_grand_total, products);
                    localStorage.setItem("pur_reg_" + this.order_id, "1");
                }


            });


        })


    }

    ngOnDestroy(): void {
    }

}
